// import React, { createContext, useState, useCallback, useRef } from "react";

// export const GlobalLoaderContext = createContext();

// export const GlobalLoaderProvider = ({ children }) => {
//   const [loading, setLoading] = useState(false);
//   const [percent, setPercent] = useState(0);
//   const [message, setMessage] = useState("");
//   const timeoutRef = useRef(null);
//   const intervalRef = useRef(null);

//   const startLoading = useCallback(() => {
//     // Reset state
//     setPercent(70);
//     setMessage("");

//     // Delay showing loader
//     timeoutRef.current = setTimeout(() => {
//       setLoading(true);
//       setMessage("Crunching the numbers... almost there!");
//       // Fake progress increment (just for UI feedback)
//       let current = 70;
//       intervalRef.current = setInterval(() => {
//         current += 10;
//         if (current > 90) current = 90; // don’t exceed 90, wait for stopLoading
//         setPercent(current);
//       }, 500);
//     }, 14000);
//   }, []);

//   const stopLoading = useCallback(() => {
//     setLoading(false);
//     setPercent(0);
//     setMessage("");

//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//       timeoutRef.current = null;
//     }
//     if (intervalRef.current) {
//       clearInterval(intervalRef.current);
//       intervalRef.current = null;
//     }
//   }, []);

//   const stopLoadingCross = useCallback(() => {
//     stopLoading();
//   }, [stopLoading]);

//   const updateProgress = (val) => {
//     setPercent(val);
//   };

//   const runWithLoader = useCallback(async (fn) => {
//     try {
//       startLoading();
//       await fn();
//     } catch (err) {
//       console.error("Global loader caught error:", err);
//       throw err;
//     } finally {
//       stopLoading();
//     }
//   }, [startLoading, stopLoading]);

//   return (
//     <GlobalLoaderContext.Provider
//       value={{
//         loading,
//         percent,
//         message,
//         startLoading,
//         stopLoading,
//         stopLoadingCross,
//         updateProgress,
//         runWithLoader,
//       }}
//     >
//       {children}
//     </GlobalLoaderContext.Provider>
//   );
// };
import React, { createContext, useState, useCallback, useRef } from "react";

export const GlobalLoaderContext = createContext();

export const GlobalLoaderProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0); // counter
  const [percent, setPercent] = useState(0);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false); // 👈 actual flag for showing UI
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  const startLoading = useCallback((onVisible) => {
    setLoadingCount((prev) => {
      const newCount = prev + 1;

      if (newCount === 1) {
        setPercent(70);
        setMessage("");

        // Delay showing loader by 4s
        timeoutRef.current = setTimeout(() => {
          setVisible(true); // 👈 show only after 4s
          setMessage("Crunching the numbers... almost there!");
          if (onVisible) onVisible(); // 👈 tell component to hide local loader

          let current = 70;
          intervalRef.current = setInterval(() => {
            current += 5;
            if (current > 90) current = 90;
            setPercent(current);
          }, 500);
        }, 4000);
      }

      return newCount;
    });
  }, []);

  const stopLoading = useCallback(() => {
    setLoadingCount((prev) => {
      const newCount = Math.max(0, prev - 1);

      if (newCount === 0) {
        setPercent(0);
        setMessage("");
        setVisible(false); // 👈 hide immediately when no loaders left

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }

      return newCount;
    });
  }, []);

  const stopLoadingCross = useCallback(() => {
    setLoadingCount(0);
    setPercent(0);
    setMessage("");
    setVisible(false);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const updateProgress = (val) => {
    setPercent(val);
  };

  const runWithLoader = useCallback(
    async (fn, onVisible) => {
      try {
        startLoading(onVisible); // pass callback
        await fn();
      } catch (err) {
        console.error("Global loader caught error:", err);
        throw err;
      } finally {
        stopLoading();
      }
    },
    [startLoading, stopLoading]
  );

  const resetLoader = useCallback(() => {
    setLoadingCount(0);
    setPercent(0);
    setMessage("");
    setVisible(false);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  return (
    <GlobalLoaderContext.Provider
      value={{
        loading: visible, // 👈 use `visible`
        percent,
        message,
        startLoading,
        stopLoading,
        stopLoadingCross,
        updateProgress,
        runWithLoader,
        resetLoader,
      }}
    >
      {children}
    </GlobalLoaderContext.Provider>
  );
};
